import React from 'react';

const ImageGallery = ({ images = [], selectedImageUrl, onSelect }) => {
  if (images.length === 0) {
    return (
      <p className="text-xs text-gray-500">No images generated yet. Enter a prompt above.</p>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {images.map((img, idx) => {
        const isSelected = img.imageUrl === selectedImageUrl;
        return (
          <button
            key={idx}
            onClick={() => onSelect(img.imageUrl)}
            className={`relative rounded-lg overflow-hidden border-2 transition-colors ${
              isSelected
                ? 'border-yellow-400 shadow-lg shadow-yellow-400/20'
                : 'border-gray-600 hover:border-gray-500'
            }`}
          >
            <img
              src={img.imageUrl}
              alt={`Generated ${idx + 1}`}
              className="w-full aspect-video object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent px-2 py-1.5">
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-300">#{img.iteration || idx + 1}</span>
                <span className="text-xs text-gray-400">{img.preset}</span>
              </div>
              {img.feedback && (
                <p className="text-xs text-gray-400 truncate mt-0.5">Refined: {img.feedback}</p>
              )}
            </div>
            {isSelected && (
              <div className="absolute top-2 right-2 bg-yellow-400 text-gray-900 text-xs font-bold px-2 py-0.5 rounded">
                Selected
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ImageGallery;
